/* Сессия: access + refresh в localStorage. Ключ — на приложение, чтобы тренер и клиент не мешали друг другу.
   Хранилище может быть недоступно (приватный режим) — всё в try/catch. */
export interface Session {
  access: string;
  refresh: string;
  role: 'trainer' | 'client' | 'admin' | 'marketer';
  pid: string | null;
}

let KEY = 'tg.session';
let cur: Session | null = null;
const subs = new Set<() => void>();

export function initSession(app: string) {
  KEY = 'tg.session.' + app;
  try {
    cur = JSON.parse(localStorage.getItem(KEY) || 'null');
  } catch {
    cur = null;
  }
}
export const getSession = () => cur;
export function setSession(s: Session | null) {
  cur = s;
  try {
    if (s) localStorage.setItem(KEY, JSON.stringify(s));
    else localStorage.removeItem(KEY);
  } catch {
    /* хранилище недоступно — сессия живёт до перезагрузки */
  }
  subs.forEach((f) => f());
}
export function onSession(f: () => void) {
  subs.add(f);
  return () => subs.delete(f);
}
